import { match } from 'ts-pattern';

import { TokenDenom, TokenId, useTokenPrices } from '@/hooks/useTokenPrices';
import { getUsdWithToken } from '@/utils';

const useToUsdWithDenom = () => {
  const { data: prices } = useTokenPrices();

  const oraiToUsd = (orai: number) =>
    getUsdWithToken({
      amount: orai,
      tokenId: TokenId.ORAI,
      prices: prices || {},
    });

  const airiToUsd = (airi: number) =>
    getUsdWithToken({
      amount: airi,
      tokenId: TokenId.AIRI,
      prices: prices || {},
    });

  const getPriceUsdWithDenom = (amount: number, denom: TokenDenom | string) => {
    return match(denom)
      .with(TokenDenom.ORAI, () => oraiToUsd(amount))
      .with(TokenDenom.AIRI, () => airiToUsd(amount))
      .otherwise(() => amount);
  };

  return { getPriceUsdWithDenom };
};

export default useToUsdWithDenom;
